import React from 'react';
import { ReservationDetails } from 'Molecules/';
import { Header, SubFooter } from 'Atoms/';

export default function reservationDetails() {
  return (
    <div>
      <Header
        classType="header-int"
        title1="Diamond Head"
        title2="State Monument"
        url="diamondhead"
      />
      <ReservationDetails park="61b977bae43345bd027d7bec" url="diamondhead" />
      <SubFooter name="Diamond Head State Monument" url="diamondhead" />
    </div>
  );
}
